import { motion } from "framer-motion";
import * as Icons from "lucide-react";
import { WHY_CHOOSE } from "../../lib/data";

export default function WhyChooseUs() {
  return (
    <section
      data-testid="why-choose-us"
      className="relative py-28 md:py-40 px-6 md:px-10 border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto">
        <div className="text-center max-w-3xl mx-auto mb-20">
          <div className="eyebrow mb-4">Why Choose Us</div>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-white font-light leading-tight">
            The advisory investors{" "}
            <span className="gold-gradient-text italic">trust</span> with
            generational wealth.
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-px bg-white/[0.06] border border-white/[0.06]">
          {WHY_CHOOSE.map((item, i) => {
            const Icon = Icons[item.icon] || Icons.Sparkles;
            return (
              <motion.div
                key={item.title}
                data-testid={`why-choose-${i}`}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.6, delay: i * 0.05 }}
                className="bg-[#070707] p-10 md:p-12 group hover:bg-[#0d0d0d] transition-all duration-500 relative"
              >
                <div className="flex items-start gap-5">
                  <div className="shrink-0 w-12 h-12 rounded-full border border-[#D4AF37]/40 flex items-center justify-center group-hover:border-[#D4AF37] group-hover:bg-[#D4AF37]/10 transition-all duration-500">
                    <Icon
                      className="w-5 h-5 text-[#D4AF37]"
                      strokeWidth={1.4}
                    />
                  </div>
                  <div>
                    <h3 className="font-serif text-2xl text-white font-light mb-2">
                      {item.title}
                    </h3>
                    <p className="text-white/60 text-sm leading-relaxed font-light">
                      {item.desc}
                    </p>
                  </div>
                </div>
                <span className="absolute bottom-0 left-0 h-px w-0 bg-[#D4AF37] group-hover:w-full transition-all duration-700" />
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
